document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collection-range').forEach(function (sectionEl) {
    const track = sectionEl.querySelector('.product-slider-track');
    const slides = sectionEl.querySelectorAll('.product-slider-slide');
    const prevBtn = sectionEl.querySelector('.slider-prev');
    const nextBtn = sectionEl.querySelector('.slider-next');

    if (!track || slides.length === 0) return;

    let slidesToShow = getSlidesToShow();
    let currentIndex = 0;

    function getSlidesToShow() {
      return window.innerWidth <= 990 ? 2 : 3;
    }

    function shouldEnableSlider() {
      if (window.innerWidth <= 990) {
        return slides.length > 2;
      }
      return slides.length > 3;
    }

    function updateSlider() {
      slidesToShow = getSlidesToShow();
      
      if (!shouldEnableSlider()) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        track.style.transform = 'translateX(0)';
        return;
      }

      const slideWidth = slides[0].offsetWidth + getGap();
      track.style.transform = `translateX(-${currentIndex * slideWidth}px)`;

      prevBtn.style.display = currentIndex === 0 ? 'none' : 'block';
      nextBtn.style.display =
        currentIndex >= slides.length - slidesToShow ? 'none' : 'block';
    }

    function getGap() {
      const style = window.getComputedStyle(slides[0]);
      return parseFloat(style.marginRight) || 0;
    }

    if (shouldEnableSlider()) {
      prevBtn.addEventListener('click', () => {
        if (currentIndex > 0) {
          currentIndex--;
          updateSlider();
        }
      });

      nextBtn.addEventListener('click', () => {
        if (currentIndex < slides.length - slidesToShow) {
          currentIndex++;
          updateSlider();
        }
      });

      // --- TOUCH SWIPE ---
      let startX = 0;
      let endX = 0;

      track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });

      track.addEventListener('touchmove', (e) => {
        endX = e.touches[0].clientX;
      });

      track.addEventListener('touchend', () => {
        if (window.innerWidth <= 749) {
          let diff = startX - endX;
          if (diff > 50 && currentIndex < slides.length - slidesToShow) {
            currentIndex++;
            updateSlider();
          } else if (diff < -50 && currentIndex > 0) {
            currentIndex--;
            updateSlider();
          }
        }
      });
    } else {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    }

    window.addEventListener('resize', updateSlider);
    updateSlider();
  });
});